"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeVerificationStatus = void 0;
/**
 * Normalized income-verification status token. One enum covers all three scopes the
 * partner dashboard income card renders:
 *   - per-applicant headline status (`fullyVerified | automaticallyVerified | inProgress | failed | stated | notVerified`)
 *   - per-attempt badge (`fullyVerified | failed`)
 *   - household roll-up (`fullyVerified | partiallyVerified | notVerified`)
 *
 * The backend emits these tokens; the frontend maps each token to a display string via
 * Paraglide (incomeLabels.ts). This is the blessed pattern (mirrors
 * NormalizedNotarizationStatus) and removes the prior 3-copy display-string drift.
 *
 * NOTE: `partiallyVerified` and `stated` are reserved — the backend has no producer for them
 * today (deriveApplicantStatus never returns them; grep finds no other emitter). They are the
 * candidate honest labels for accepted-as-stated income (e.g. small-line co-applicants, currently
 * shown as `automaticallyVerified` pending compliance sign-off), kept so the FE label map stays
 * exhaustive. Don't hunt for a producer — there isn't one yet.
 */
var IncomeVerificationStatus;
(function (IncomeVerificationStatus) {
    IncomeVerificationStatus["fullyVerified"] = "fullyVerified";
    IncomeVerificationStatus["automaticallyVerified"] = "automaticallyVerified";
    IncomeVerificationStatus["partiallyVerified"] = "partiallyVerified";
    IncomeVerificationStatus["inProgress"] = "inProgress";
    /** Income acceptance is blocked by pending document authentication. */
    IncomeVerificationStatus["authenticationPending"] = "authenticationPending";
    IncomeVerificationStatus["failed"] = "failed";
    IncomeVerificationStatus["stated"] = "stated";
    IncomeVerificationStatus["notVerified"] = "notVerified";
    /** Denied because verified income does not support the requested line (AAN code 1005). Amber/warning (reconsiderable), not a terminal failure. */
    IncomeVerificationStatus["insufficient"] = "insufficient";
})(IncomeVerificationStatus || (exports.IncomeVerificationStatus = IncomeVerificationStatus = {}));
